<template>
  <div class="grid-string grid-string-data children-pointers" @click="navigate">
    <Cell class="cell-left">{{ index }}. {{ list.title || 'Untitled' }}</Cell>
    <CurrencyEntry :text="one" :currency="currency" is-span />
    <CurrencyEntry :text="two" :currency="currency" is-span />
    <CurrencyEntry :text="three" :currency="currency" is-span />
    <CurrencyEntry :text="total" :currency="currency" is-bold is-span class="total-cell" />
  </div>
</template>

<script>
  import addSpaces from '@/utils/formatting/add-spaces';
  import CurrencyEntry from '@/components/common/CurrencyEntry';
  import Cell from '@/components/common/Cell';

  export default {
    name: 'SummaryListRow',
    components: { Cell, CurrencyEntry },
    props: {
      index: Number,
      one: [Number, String],
      two: [Number, String],
      three: [Number, String],
      four: [Number, String],
      total: [Number, String],
      list: {
        type: Object,
        default: () => ({
          order: Number,
          title: String,
        }),
      },
      currency: {
        type: String,
        required: true,
      },
    },
    methods: {
      addSpaces,
      navigate() {
        this.$router.push({ name: 'list', params: { list: this.list.id } });
      },
    },
  };
</script>
